import { getLocale } from "../runtime";

const sv_couponcodeplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `t.ex. HAPPYGREEN20`
};

const couponcodeplaceholder = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_couponcodeplaceholder(inputs)
	return "couponCodePlaceholder";
};

export { couponcodeplaceholder as "couponCodePlaceholder" };